"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPAN_TYPES = exports.SpanType = void 0;
/**
 * Standard Span Type values for "IkeCalc" PLA forms (not IPF)
 */
var SpanType;
(function (SpanType) {
    SpanType["NextPole"] = "NEXT_POLE";
    SpanType["PreviousPole"] = "PREVIOUS_POLE";
    SpanType["Other"] = "OTHER_POLE";
    SpanType["Building"] = "BUILDING";
})(SpanType || (exports.SpanType = SpanType = {}));
exports.SPAN_TYPES = [
    {
        type: SpanType.NextPole,
        name: 'Fore Span',
    },
    {
        type: SpanType.PreviousPole,
        name: 'Back Span',
    },
    {
        type: SpanType.Other,
        name: 'Other',
    },
    {
        type: SpanType.Building,
        name: 'Building',
    },
];
//# sourceMappingURL=constants.js.map